import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    errorGettingProject: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            errorGettingProject: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FoldersView.errorGettingProject?c=3678r3trq373t", defaultMessage: "An error has occurred retrieving the Project" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
